export enum UserPermissionEnum {
  ADMIN = 'ADMINISTRADOR',
  LEGAL_STATE_REPRESENTATIVE = 'REPRESENTANTE LEGAL ESTADUAL',
  STATE_MANAGER = 'GERENTE ESTADUAL',
  STATE_OPERATOR = 'OPERADOR ESTADUAL',
  STATE_COUNSELOR = 'CONSELHEIRO ESTADUAL',
  LEGAL_MUNICIPAL_REPRESENTATIVE = 'REPRESENTANTE LEGAL MUNICIPAL',
  MUNICIPAL_MANAGER = 'GERENTE MUNICIPAL',
  MUNICIPAL_OPERATOR = 'OPERADOR MUNICIPAL',
  MUNICIPAL_COUNSELOR = 'CONSELHEIRO MUNICIPAL',
  LEGAL_AGROINDUSTRY_REPRESENTATIVE = 'REPRESENTANTE LEGAL AGROINDÚSTRIA',
  AGROINDUSTRY_MANAGER = 'GERENTE AGROINDÚSTRIA',
  LEGAL_ASSOCIATION_REPRESENTATIVE = 'REPRESENTANTE LEGAL ASSOCIAÇÃO',
  ASSOCIATION_MANAGER = 'GERENTE ASSOCIAÇÃO',
  LEGAL_COOPERATIVE_REPRESENTATIVE = 'REPRESENTANTE LEGAL COOPERATIVA',
  COOPERATIVE_MANAGER = 'GERENTE COOPERATIVA',
  FAMILY_FARMER = 'AGRICULTOR(A) FAMILIAR',
}

export const getUserPermissionValues = (): string[] => Object.values(UserPermissionEnum);
